const getters = {
  employeeRoleDefinitions: (state) => state.employeeRoleDefinitions || [],
};

export default getters;
